/**
 * 도급사업관리 적격수급인 평가서(SUB_BASIC_02) 컬럼 정의
 * SUB_BASIC_02 화면 전용 컬럼 정의
 */

import CreateColumn from '../../../../Services/agGrid/createColumn';

/**
 * 도급사업관리 적격수급인 평가서 컬럼 정의 생성
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    // 업체명 컬럼
    CreateColumn('custNm', '업체명', 'left', 200, false, false, false, 'text', {
      minWidth: 200,
    }),
    // 상반기/하반기 컬럼
    CreateColumn(
      'sbmHalf',
      '상반기/하반기',
      'center',
      150,
      false,
      false,
      false,
      'text',
      {
        minWidth: 150,
        valueFormatter: (params) => {
          if (!params.value) return '';
          return params.value === '1'
            ? '상반기'
            : params.value === '2'
              ? '하반기'
              : params.value;
        },
      }
    ),
    // 평가자의견 컬럼
    CreateColumn(
      'evaluatorOpinion',
      '평가자의견',
      'left',
      100,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 100,
      }
    ),
    // 평가자 컬럼
    CreateColumn('name', '평가자', 'left', 150, false, false, false, 'text', {
      minWidth: 150,
    }),
    // 평가일 컬럼
    CreateColumn(
      'updateDate',
      '평가일',
      'center',
      150,
      false,
      false,
      false,
      'date',
      {
        minWidth: 150,
        valueFormatter: (params) => {
          if (!params.value) return '';
          const date = new Date(params.value);
          if (isNaN(date.getTime())) return '';

          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');

          return `${year}-${month}-${day}`;
        },
      }
    ),
    // 총배점 컬럼
    CreateColumn(
      'totalScore',
      '총배점',
      'center',
      150,
      false,
      false,
      false,
      'number',
      {
        minWidth: 150,
      }
    ),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
